// 扩展页面
<template>
  <div class="expand">
    <el-dialog
      :title="$t('cooperation.message.expandApply')"
      :visible.sync="dialogVisible"
      width="80%"
      append-to-body
      center
      :before-close="handleClose"
    >
      <vxe-grid
        border
        show-overflow
        resizable
        ref="expandtable"
        class="vxe-table-element"
        height="200"
        size="mini"
        align="center"
        :edit-rules="editRules"
        :auto-resize="true"
        :data="tableData"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :valid-config="{ autoPos: true, message: 'inline' }"
      >
        <vxe-table-column type="index" width="50"></vxe-table-column>
        <vxe-table-column
          field="partnerZhName"
          :title="$t('cooperation.label.partnerZhName')"
        ></vxe-table-column>
        <!-- 扩展合作伙伴类型 -->
        <vxe-table-column
          field="extendType"
          :title="$t('cooperation.label.extendType')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              clearable
              filterable
              @change="partnerTypeChange"
              v-model="scope.row.extendType"
              :placeholder="$t('cooperation.placeholder.extendType')"
            >
              <el-option
                v-for="item in extendTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <!-- <!== 法人类型 ==>
        <vxe-table-column
          field="legalEntityType"
          :title="$t('cooperation.label.legalEntityType')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              clearable
              filterable
              v-model="scope.row.legalEntityType"
              @change="legalEntityTypeChange"
              :placeholder="$t('cooperation.placeholder.legalEntityType')"
            >
              <el-option
                v-for="item in legalList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column> -->
        <!-- 选择扩展部门 -->
        <vxe-table-column
          field="extendRequestDepartment"
          :title="$t('cooperation.label.extendRequestDepartment')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <!-- <el-select
              clearable
              filterable
              multiple
              value-key="personDepartmentCode"
              @change="selectDepartment"
              v-model="scope.row.extendRequestDepartment"
              :placeholder="$t('cooperation.placeholder.extendRequestDepartment')"
            >
              <el-checkbox class="selectAll" v-model="checked" @change="selectAll(scope)"
                >全选</el-checkbox
              >
              <el-option
                v-for="item in extendRequestDepartmentList"
                :key="item.personDepartmentCode"
                :label="item.personDepartmentName"
                :value="item"
              ></el-option>
            </el-select> -->
            <tree-select
              ref="treeSelect"
              :model="scope.row.extendRequestDepartment"
              :placeholder="$t('cooperation.placeholder.extendRequestDepartment')"
              :apiUrl="getApi"
              :apiData="getApiInfo"
              :clearable="true"
              :multiple="true"
              returnType="Object"
              @setSearchModal="(model, row) => setSearchModal(model, row, scope)"
            ></tree-select>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="extendRequestPerson"
          :title="$t('cooperation.label.extendRequestPerson')"
        ></vxe-table-column> -->
        <!-- 销售对账科目 -->
        <!-- <vxe-table-column
          field="sellReconciliationSubject"
          :title="$t('cooperation.label.sellReconciliationSubjectEx')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              :disabled="sellForbid"
              :clearable="true"
              :filterable="true"
              :placeholder="$t('cooperation.placeholder.sellReconciliationSubject')"
              v-model="scope.row.sellReconciliationSubject"
              @change="sellReconciliationSubjectChange"
            >
              <el-option
                v-for="item of subjectList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column> -->
        <!-- 采购对账科目 -->
        <!-- <vxe-table-column
          field="procurementReconciliationSubject"
          :title="$t('cooperation.label.procurementReconciliationSubjectEx')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              :disabled="purchaseForbid"
              :clearable="true"
              :filterable="true"
              :placeholder="$t('cooperation.placeholder.procurementReconciliationSubject')"
              v-model="scope.row.procurementReconciliationSubject"
              @change="procurementReconciliationSubjectChange"
            >
              <el-option
                v-for="item of subjectProcureList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column> -->
      </vxe-grid>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="save">{{ $t('cooperation.buttons.sure') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/masterData/cooperation.js';
  import BASE_API from '@/api/dataBase';
  import treeSelect from '@/components/form-item/tree-select';

  import { mapState } from 'vuex';
  // import { dateTimeFormat } from '@/filters'; // 导入时间格式化方法
  export default {
    name: 'expand',
    components: {
      treeSelect,
      // SiruiTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      getApi() {
        return BASE_API.LIST_COMPANY_DEPT_TREE;
      },
      getApiInfo() {
        return {
          tenantCode: this.userInfo.tenantCode,
          adminFlag: this.userInfo.adminFlag,
          userCode: this.userInfo.userCode,
          selfCompanyDepartmentTreeFlag: true,
        };
      },
      // 校验规则
      editRules() {
        return {
          extendType: [
            { required: true, message: window.vm.$t('cooperation.placeholder.extendType') },
          ],
          extendRequestDepartment: [{ required: true, message: '请填写申请拓展部门' }],
          // legalEntityType: [
          //   { required: true, message: window.vm.$t('cooperation.placeholder.legalEntityType') },
          // ],
          // sellReconciliationSubject: [
          //   { required: !this.sellForbid, message: '请选择销售对账科目' },
          // ],
          // procurementReconciliationSubject: [
          //   { required: !this.purchaseForbid, message: '请选择采购对账科目' },
          // ],
        };
      },
    },
    props: {
      forbidden: {
        type: Boolean,
        default: () => true,
      },
      // purchaseSubjectRule: {
      //   type: Array,
      //   default: () => [],
      // },
      // sellSubjectRule: {
      //   type: Array,
      //   default: () => [],
      // },
      // subjectProcureList: {
      //   type: Array,
      //   default: () => [],
      // },
      // subjectList: {
      //   type: Array,
      //   default: () => [],
      // },
    },
    data() {
      return {
        sellForbid: true,
        purchaseForbid: true,
        dialogVisible: false,
        load: false,
        checked: false,
        extendRequestDepartment: [],
        tableData: [
          {
            extendType: '',
            // legalEntityType: '',
            // extendRequestPerson: '',
            // sellReconciliationSubject: '', //销售对账科目
            // procurementReconciliationSubject: '', //采购对账科目
            // sellReconciliationSubjectDesc: '', // 对账科目描述
            // procurementReconciliationSubjectDesc: '', // 对账科目描述
          },
        ],
        companyInfo: {},
        propsPartnerData: null, // 存储重复的合作伙伴对象
        extendTypeList: [], // 扩展类型
        extendRequestDepartmentList: [], //扩展部门列表
        departmentList: [], //所选部门列表
        legalList: [], // 法人分类数据
        legalEntityTypeList: [], // 法人分类数据
        customerLegalEntityTypeList: [], // 客户法人分类数据
        repeatData: '', // 重复字段
        // editRules:{
        //   extendType: [
        //     { required: true, message: window.vm.$t('cooperation.placeholder.extendType') },
        //   ],
        //   sellReconciliationSubject: sellSubjectRule,
        //   procurementReconciliationSubject: purchaseSubjectRule,
        // }
      };
    },
    mounted() {
      this.getDictList();
    },
    methods: {
      setSearchModal(model, row, scope) {
        // this.params[model] = row;
        console.log('expand selected row', row, scope);
        let list = Array.from(row.split(','));
        // scope.row.extendRequestDepartment = row;
        this.departmentList = list;
      },
      // 打开弹窗
      openDialog(data, partnerTypeList, value, extendRequestDepartmentList, companyInfo) {
        this.tableData = []; // 解决重复打开扩展弹窗，数据重复问题
        this.propsPartnerData = data;
        console.log(this.propsPartnerData);
        this.extendTypeList = partnerTypeList;
        this.extendRequestDepartmentList = extendRequestDepartmentList;
        this.companyInfo = companyInfo;
        for (let i = 0; i < this.extendTypeList.length; i++) {
          if (this.extendTypeList[i].value == 'HZHB04') {
            this.extendTypeList.splice(i, 1);
          }
        }
        this.repeatData = value;

        console.log('partnerName', this.propsPartnerData.partnerZhName);
        const obj = {
          partnerZhName: this.propsPartnerData.partnerZhName || this.propsPartnerData.label,
          extendRequestDepartment: '',
          extendRequestPerson: this.userInfo.userName,
          extendType: '',
          legalEntityType: '',
          extendRequestDepartmentList: '',
          // sellReconciliationSubject: '', //销售对账科目
          // procurementReconciliationSubject: '', //采购对账科目
          // sellReconciliationSubjectDesc: '', // 对账科目描述
          // procurementReconciliationSubjectDesc: '', // 对账科目描述
        };
        this.tableData.push(obj);
        this.$nextTick(() => {
          this.dialogVisible = true;
        });
      },
      // 销售数据对账科目变化
      sellReconciliationSubjectChange(value) {
        console.log(value);
        if (value) {
          this.tableData[0].sellReconciliationSubject = value;
          this.tableData[0].sellReconciliationSubjectDesc = value;
        } else {
          this.tableData[0].sellReconciliationSubject = '';
          this.tableData[0].sellReconciliationSubjectDesc = '';
        }
      },
      // 采购数据对账科目变化
      procurementReconciliationSubjectChange(value) {
        if (value) {
          this.tableData[0].procurementReconciliationSubject = value;
          this.tableData[0].procurementReconciliationSubjectDesc = value;
        } else {
          this.tableData[0].procurementReconciliationSubject = '';
          this.tableData[0].procurementReconciliationSubjectDesc = '';
        }
      },
      partnerTypeChange(value) {
        this.tableData[0].extendType = value;
        this.tableData[0].legalEntityType = '';
        this.legalList =
          value == 'HZHB01' || value == 'HZHB03' || value == 'HZHB10' || value == 'HZHB11'
            ? this.customerLegalEntityTypeList
            : this.legalEntityTypeList;
        this.tableData[0].sellReconciliationSubject = '';
        this.tableData[0].sellReconciliationSubjectDesc = '';
        this.tableData[0].procurementReconciliationSubject = '';
        this.tableData[0].procurementReconciliationSubjectDesc = '';
        this.resolveSellRules(value);
      },
      // 根据合作伙伴类型判断销售、采购的检验状态
      resolveSellRules(value) {
        if (value === 'HZHB01' || value === 'HZHB10') {
          // 客户
          this.sellForbid = false;
          this.purchaseForbid = true;
        } else if (value === 'HZHB03') {
          // 合作伙伴
          this.sellForbid = false;
          this.purchaseForbid = false;
        } else {
          // 其他
          this.sellForbid = true;
          this.purchaseForbid = false;
        }
      },
      legalEntityTypeChange(value) {
        this.tableData[0].legalEntityType = value;
      },
      selectDepartment(value) {
        console.log('执行了');
        console.log(value);
        if (value) {
          this.departmentList = value;
          if (value.length === this.extendRequestDepartmentList.length) {
            this.checked = true;
          } else {
            this.checked = false;
          }
        }
      },
      // 全选
      selectAll(scope) {
        console.log(this.checked);
        // console.log(scope.row.extendRequestDepartment);
        this.departmentList = [];
        if (this.checked) {
          this.extendRequestDepartmentList.map((item) => {
            this.departmentList.push(item);
            scope.row.extendRequestDepartment.push(item);
          });
          console.log(this.departmentList);
        } else {
          this.departmentList = [];
          scope.row.extendRequestDepartment = [];
        }
      },
      // 获取被扩展对象详情
      save() {
        // if(this.departmentList.length==1){
        //   this.saveSingle()
        // }else{
        this.saveMul();
        // }
      },
      saveMul() {
        let partnersExtendDTOList = [];

        this.departmentList.forEach((item) => {
          let partnersExtendDTO = {};
          partnersExtendDTO.extendRequestDepartment = item;
          partnersExtendDTO.extendType = this.tableData[0].extendType;
          partnersExtendDTO.legalEntityType = this.tableData[0].legalEntityType;
          console.log(partnersExtendDTO.legalEntityType);
          partnersExtendDTOList.push(partnersExtendDTO);
        });
        let companyInfo = this.companyInfo;
        console.log(companyInfo);
        const pararms = {
          ...companyInfo,
          partnerCode: this.propsPartnerData.partnerCode,
          partnersExtendDTOList,
          sellReconciliationSubject: this.tableData[0].sellReconciliationSubject,
          sellReconciliationSubjectDesc: this.tableData[0].sellReconciliationSubjectDesc,
          procurementReconciliationSubject: this.tableData[0].procurementReconciliationSubject,
          procurementReconciliationSubjectDesc:
            this.tableData[0].procurementReconciliationSubjectDesc,
        };
        if (this.departmentList.length == 0 || this.tableData[0].extendType.length == 0) {
          this.$message.error('请检查数据是否填写完整！');
          return;
        }
        this.$axios.post(API.SAVE_PARTNER_EXTEND, pararms).then((res) => {
          if (res.data.code === 0) {
            // this.$emit("getExpandData", data); // 返回扩展数据
            // this.$emit("partnerTypeChange"); // 合作伙伴类型切换
            // this.$emit("changeCountry"); // 获取省份市
            this.$emit('getDetail', this.companyInfo.departmentCode);
            this.dialogVisible = false;
            this.$message({ showClose: true, message: '合作伙伴扩展成功！', type: 'success' });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // this.$refs.expandtable.validate((valid) => {
        //   if (valid) {

        //   }
        // });
      },
      // 关闭弹窗
      handleClose() {
        this.$emit('clearRepeatData', this.repeatData);
        this.dialogVisible = false;
      },
      // 获取字典值
      getDictList() {
        const tenantCode = this.userInfo.tenantCode;
        // 法人分类
        this.$axios
          .post(API.DICT_LIST, { dictType: 'legal_entity_type', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.legalEntityTypeList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 客户法人分类
        this.$axios
          .post(API.DICT_LIST, { dictType: 'customer_legal_entity_type', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.customerLegalEntityTypeList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .expand {
    .vxe-toolbar {
      display: none;
    }
  }

  .selectAll {
    text-align: left;
    width: 100%;
    margin-left: 22px;
  }
</style>
